const DTMF_FREQUENCIES: Record<string, [number, number]> = {
  "1": [697, 1209], "2": [697, 1336], "3": [697, 1477],
  "4": [770, 1209], "5": [770, 1336], "6": [770, 1477],
  "7": [852, 1209], "8": [852, 1336], "9": [852, 1477],
  "*": [941, 1209], "0": [941, 1336], "#": [941, 1477],
};

let audioCtx: AudioContext | null = null;

function getAudioContext(): AudioContext {
  if (!audioCtx) audioCtx = new AudioContext();
  return audioCtx;
}

export function playDtmfTone(key: string, durationMs = 200): void {
  const freqs = DTMF_FREQUENCIES[key];
  if (!freqs) return;

  const ctx = getAudioContext();
  const gain = ctx.createGain();
  gain.gain.value = 0.2;
  gain.connect(ctx.destination);

  const osc1 = ctx.createOscillator();
  osc1.type = "sine";
  osc1.frequency.value = freqs[0];
  osc1.connect(gain);

  const osc2 = ctx.createOscillator();
  osc2.type = "sine";
  osc2.frequency.value = freqs[1];
  osc2.connect(gain);

  const now = ctx.currentTime;
  osc1.start(now);
  osc2.start(now);
  osc1.stop(now + durationMs / 1000);
  osc2.stop(now + durationMs / 1000);
}

export function sendDtmf(session: any, key: string): void {
  playDtmfTone(key);
  session?.dtmf?.()?.insertDTMF?.(key, 500);
}
